import React from 'react';
import { Button, FontIcon } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';
import { useTranslation } from 'react-i18next';
import { translationKeys } from './i18n/en';

interface GrubhubButtonProps {
  url: string;
  canOrderNow: boolean;
}

const blockName = 'grubhub-button';

const GrubhubButton: React.FC<GrubhubButtonProps> = props => {
  const bem = bemBlock(blockName);
  const { t } = useTranslation();

  return (
    <Button
      className={bem()}
      type="a"
      externalLink
      href={props.url}
      size="lg"
      append={<FontIcon name="chevronRight" />}
    >
      {props.canOrderNow ? t(translationKeys.orderOnGrubhub) : t(translationKeys.browseGrubhub)}
    </Button>
  );
};

export default GrubhubButton;
